import { useState } from "react";
import { axios } from "../../../services";

export const useSendMessage = (communityId, userId) => {
  const [loading, setLoading] = useState(false);

  const sendMessage = async (message) => {
    if (!message.trim()) return;
    setLoading(true);

    try {
      await axios.post(`/chat/${communityId}`, {
        sender: userId,
        message,
      });
    } catch (err) {
      console.log("Error sending message:", err);
    } finally {
      setLoading(false);
    }
  };

  return { sendMessage, loading };
};
